import Model from "../Model";
import ValidatableObject from "../validation/ValidatableObject";

export interface TFormTypesGroupCategory {
  code: string;
  name: string;
  valid: boolean;
}

export interface IFormTypesGroupCategory extends TFormTypesGroupCategory {}

const FormTypesGroupCategory = Model(
  (model: TFormTypesGroupCategory): IFormTypesGroupCategory => {
    const _formTypesGroupCategory: TFormTypesGroupCategory = Object.assign(
      {},
      model
    );

    let create = (
      formTypesGroupCategory: IFormTypesGroupCategory
    ): IFormTypesGroupCategory => {
      let obj = ValidatableObject(formTypesGroupCategory);
      return obj;
    };

    let formTypesGroupCategory = {
      get code() {
        return _formTypesGroupCategory.code;
      },
      set code(value) {
        _formTypesGroupCategory.code = value;
      },
      get name() {
        return _formTypesGroupCategory.name;
      },
      set name(value) {
        _formTypesGroupCategory.name = value;
      },
      get valid() {
        return _formTypesGroupCategory.valid;
      },
      set valid(value) {
        _formTypesGroupCategory.valid = value;
      }
    };

    return create(formTypesGroupCategory);
  }
);

export default FormTypesGroupCategory;
